module.exports = __webpack_public_path__ + "img/spotify.b4907142.svg";